<template>
    <div class="HomeRank">
        
        <div class="HomeRank_box">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>{{Detailstitle}}</span>
                </div>
                <ul class="CardList">
                    <li v-for="(o,index) in dataArr" :key="index" >
                        <div class="CardList_rank">
                            <p>{{o.Rank}}°</p>
                            <p>#{{o.ShirtNumber}}</p>
                        </div>
                        <div class="CardList_symbol"> | </div>
                        <div class="CardList_name">
                            <p>{{o.RegisterName}}</p>
                            <p>{{o.TeamName}}</p>
                        </div>
                        <div class="CardList_data">
                            <p>{{o.Ratio}}</p>
                            <p>{{o.RatioDes}}</p>
                        </div>
                    </li>
                    <!-- <div class="more_ranking">
                    <el-button type="primary" icon="el-icon-s-unfold" @click="handleMore"></el-button>
                    </div> -->
                    
                </ul>
                <div class="paging_box">
                    <!-- <span class="demonstration">调整每页显示条数</span> -->
                    <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="PageIndex"
                    :page-sizes="[10,20,50,100,150,200,250,300,500]"
                    :page-size="PageSize"
                    layout="sizes, prev, pager, next"
                    :total="TotalCount">
                    </el-pagination>
                </div>
            </el-card>

        </div>

    </div>
</template>
<script>
import http from '@/assets/js/http.js';
export default {
    data(){
        return {
            // currentPage2: 5,
            Detailstitle:'',
            PageIndex: 1,
            TotalCount: 0,
            PageSize: 10,
            dataArr: [],
            fromPath:'',
        }
    },
    watch: {
        $route: { // 亲测有效,我是用来监听query参数变化
            handler(newVal,oldVal) {
                // this.id = this.$route.query.id;
                // this.getDetail();
                // console.log('这是新值:',newVal)
                // console.log('这是laozhi:',oldVal)
                //深度监听，同时也可监听到param参数变化
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
                // this.my_data = params;
                // this.PhaseID = params.phaseID;
                // this.PhaseName = params.phaseName;
                console.log(params)
            },
            deep: true,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
            // console.log(to)
            // console.log(from)
            vm.fromPath = from.path;
        })
    },
    created(){
        let cookiePage = Number(this.$cookie.get('HoPageIndex'));
        let cookieSize = Number(this.$cookie.get('HoPageSize'));
        this.PageIndex = cookiePage;
        // console.log(cookiePage)
        this.$nextTick(() =>{
            if(this.fromPath == '/'){
                this.PageIndex = cookiePage;
                if(cookieSize != 0){
                    this.PageSize = cookieSize;
                }
            }else{
                this.PageIndex = 1;
                this.PageSize = 10;
                this.$cookie.set('HoPageSize',10,'2h');
                this.$cookie.set('HoPageIndex',1,'2h');
            }   
            this.GetEventStatList(this.my_data.EventID,this.my_data.details,this.PageIndex,this.PageSize)//获取首页9大统计数据接口-详情
        })
        
        
        let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
        console.log(params)
        this.my_data = params;
        // if(){
        
        // }

        this.Detailstitle = params.details == '1' ? '最佳得分手(得分 / 局)' :
         params.details == '2' ? '最佳发球手(发球得分 / 局)' :
         params.details == '3' ? '最佳拦网手(拦网得分 / 局)' :
         params.details == '4' ? '最佳得分手(得分)' :
         params.details == '5' ? '最佳发球手(发球得分)' :
         params.details == '6' ? '最佳拦网手(拦网得分)' :
         params.details == '7' ? '最佳扣球手(扣球得分 / 局)' :
         params.details == '8' ? '最佳扣球手(扣球得分)' :
         params.details == '9' ? '最佳一传手(非常到位 - 失误) / 局' : '';
        // console.log(params)
        // setTimeout
        
    },
    mounted(){
        // this.Detailstitle = this.$cookie.get('Detailstitle');
        // this.SportID = this.$cookie.get('SportID');
        // console.log(this.$route)
        // if(){

        // }
        // console.log(this.$router.history)
        // console.log(this.$store.state.previousRouter.name)
    },
    methods: {
        handleSizeChange(val) {//选择每页多少条数据
            // console.log(`每页 ${val} 条`);
            this.PageSize = val;
            this.PageIndex = 1;
            // this.my_data.pageSize = val;
            this.$cookie.set('HoPageSize',val,'2h');
            this.GetEventStatList(this.my_data.EventID,this.my_data.details,this.PageIndex,this.PageSize)//获取首页9大统计数据接口-详情
        },
        handleCurrentChange(val) {//选择页码
            // console.log(`当前页: ${val}`);
            this.PageIndex = val;
            this.$cookie.set('HoPageIndex',val,'2h');
            // this.my_data.pageIndex = val;
            this.GetEventStatList(this.my_data.EventID,this.my_data.details,this.PageIndex,this.PageSize)//获取首页9大统计数据接口-详情
            
            window.scrollTo({
                top: 0,
                behavior: 'smooth',//平滑滚动
            })

        },
        GetEventStatList(EventID,Type,PageIndex,PageSize){//获取首页9大统计数据接口-详情
            http.GetEventStatList(EventID,Type,PageIndex,PageSize).then(res=>{////获取首页9大统计数据接口
                // console.log(res)
                if(res.Status == 1){
                    this.dataArr = res.DataResult;
                    this.TotalCount = res.TotalCount;
                }else if(res.Status == 0){
                    this.dataArr = [];
                    this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                }else{
                    this.dataArr = [];
                    this.$message.error({
                        message:'获取信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                }
                
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    .HomeRank{
        max-width: 1200px;
        margin: 20px auto;
    }
    .HomeRank_box{
        width: 55%;
        font-size: 16px;
        margin: 0 auto;
    }
    .CardList{
        width: 100%;
        li{
            width: 100%;
            padding: 10px 0;
            border-bottom: 1px solid #EBEEF5;
            display: flex;
            .CardList_rank{
                // flex: 1;
                width: 10%;
            }
            .CardList_symbol{
                width: 4%;
            }
            .CardList_name{
                flex: 1;
                text-align: left;
            }
            .CardList_data{
                width: 25%;
                // display: flex;
                // align-items: center;
                // align-content: center;
                // // justify-items: center;
                // flex-wrap: wrap;
                // p{
                //     width: 100%;
                //     // flex: 1 1 at;
                //     // align-items: center;
                // }
            }
        }
        .more_ranking{
        margin-top: 10px;
        }
    }
    .paging_box{
        margin-top: 10px;
    }
    
</style>